import React from 'react'
import PropTypes from 'prop-types'

import { v4 as uuidv4 } from 'uuid'

import cn from 'classnames'

import './index.scss'

const TextAreaInput = props  => {
  const [ state, setState ] = React.useState({
    id: props.id || uuidv4(),
  })

  return <div className={cn( 'textarea-container', props.className, { error: props.hasError } ) }>
    <textarea
      className={`textarea ${props.className || ''} ${props.value ? 'has-value' : ''}`}
      id={state.id}
      value={props.value || ''}
      onChange={ e => props.onChange(e.target.value) }
      onFocus={ () => props.onFocus() }
      autoFocus={props.autoFocus}
      />
    <label className={cn({isValid: props.value.trim().length > 0})} htmlFor={state.id}>{props.label}</label>
  </div>
}

TextAreaInput.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  hasError: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  value: PropTypes.string,
}

TextAreaInput.defaultProps = {
  autoFocus: false,
  className: '',
  hasName: false,
  onFocus: () => {},
}

export default TextAreaInput
